import { render, staticRenderFns } from "./CodeCard.vue?vue&type=template&id=6d3108d5&scoped=true"
import script from "./CodeCard.vue?vue&type=script&lang=js"
export * from "./CodeCard.vue?vue&type=script&lang=js"
import style0 from "./CodeCard.vue?vue&type=style&index=0&id=6d3108d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3108d5",
  null
  
)

export default component.exports